import { Badge, Box, Button, Modal, Tab, Table, Tabs } from "@mui/material";
import { useState } from "react";
import FlashIcon from "../../Assets/Icons/more.png";
import GamerDetailsFetcher from "./gamer";

const PlayerProfile: React.FC<{ uid: string }> = ({ uid }) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <img src={FlashIcon} height={25} />
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Box sx={{ ...style, display: "flex", flexDirection: "column" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab label="Account 🐕‍🦺" />
              <Tab label="Gaming Results 🎮" />
              <Tab label="Payout 💰" />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <div
              style={{
                height: "100%",
                background: "transparent",
              }}
            >
              <GamerDetailsFetcher gamerUid={uid} />
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <div style={{ height: "100%", background: "tomato" }}>
              <Table></Table>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <div style={{ height: "100%", background: "purple" }}></div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <h1></h1>
          </CustomTabPanel>
        </Box>
      </Modal>
    </>
  );
};

export default PlayerProfile;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  height: "80vh",
  overflow: "hidden",
  p: 4,
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{
        flex: 1, // Tells the tab panel to grow and fill remaining space
        display: value === index ? "flex" : "none", // Keeps flex layout when active
        flexDirection: "column",
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, flex: 1, maxHeight: "100%", overflowY: "scroll" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
